module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"internal_call":"Internal Call","internal_chat":"Internal Chat","consult":"Consultation"},"es":{"internal_call":"Llamada Interna","internal_chat":"Chat Interno","consult":"Solicitud de Consulta"}}')
  delete Component.options._Ctor
}
